import React, {useState, useRef, useEffect} from 'react';
import PhoneStageUI from './PhoneStage.ui';

const PhoneStage = ({ onSubmit, data = {} }) => {
  const [phone, setPhone] = useState(data.phone || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(data.error || '');
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handlePhoneChange = (value) => {
    const digits = (value || '').toString().replace(/\D/g, '').slice(0, 10);
    setPhone(digits);
    if (error) setError('');
  };

  const submit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const normalized = (phone || '').toString().replace(/\D/g, '');
    if (!/^05\d{8}$/.test(normalized)) {
      setError('רגע... אנחנו לא מזהים את המספר, שננסה שוב?');
      return;
    }

    if (!onSubmit) return;

    try {
      if (isMountedRef.current) setLoading(true);
      const result = onSubmit(normalized);
      if (result && typeof result.then === 'function') {
        await result;
      }
    } catch (err) {
      if (isMountedRef.current) setError((err && err.message) || 'שגיאה בשליחה, נסה שנית');
    } finally {
      if (isMountedRef.current) setLoading(false);
    }
  };

  return (
      <PhoneStageUI
        phoneLabel={data.phoneLabel}
        title={data.title}
        phone={phone}
        onPhoneChange={handlePhoneChange}
        onSubmit={submit}
        loading={loading}
        error={error}
      />
  );
};

export default PhoneStage;
